import axios from 'axios'

import { DEFAULT_TIMEOUT_MS } from '../utils/constants'
import { commonChartOptions, CommonChartConfig } from './common'
import type { BaseContext } from './'

export namespace Test {
  const CONTEXT_ID = 'test'

  export const __typelist: {
    config: ChartConfig
    data: ChartData
    context: ContextType
  } = {} as any

  export type ContextType = BaseContext<
    typeof CONTEXT_ID,
    ChartConfig,
    ChartData
  >

  export interface ChartConfig extends CommonChartConfig {
    params: {
      idx: number
    }
    chartType: 'line' | 'column'
    context: typeof CONTEXT_ID
  }

  export interface ChartData {
    title: string
    data: {
      name: string
      data: [number, number][]
    }[]
  }

  export const Context: ContextType = {
    id: CONTEXT_ID,
    getChartId: (config) => `testchart-${config.params.idx}`,
    getChartData: async (config, requestModifier = (req) => req) => {
      const response = await axios(
        requestModifier({
          timeout: DEFAULT_TIMEOUT_MS,
          url: config.url,
          params: config.params,
          method: 'GET',
        })
      )
      return response.data
    },
    getChartProps: (config, data) => {
      const series = data.data.map((s) => ({
        id: s.name,
        type: config.chartType,
        name: s.name,
        yAxis: 'default',
        data: s.data,
      }))
      const yAxis = [
        {
          id: 'default',
          title: { text: 'Label eixo y' },
          opposite: false,
        },
      ]

      return {
        id: Test.Context.getChartId(config),
        title: data.title,
        options: {
          ...commonChartOptions,
          series,
          yAxis,
        },
        stockTools: true,
      }
    },
  }
}
